(function () {
  function initBlogArchive(root) {
    if (!root || root.dataset.blogArchiveInit) return;
    root.dataset.blogArchiveInit = '1';

    var items      = Array.prototype.slice.call(root.querySelectorAll('[data-blog-item]'));
    var tabs       = Array.prototype.slice.call(root.querySelectorAll('[data-blog-filter]'));
    var searchEl   = root.querySelector('[data-blog-search]');
    var emptyEl    = root.querySelector('[data-blog-empty]');
    var paginateEl = root.querySelector('[data-blog-pagination]');
    var prevBtn    = root.querySelector('[data-blog-prev]');
    var nextBtn    = root.querySelector('[data-blog-next]');
    var statusEl   = root.querySelector('[data-blog-page-status]');
    var perPage    = parseInt(root.dataset.perPage, 10) || 24;

    var state = { category: 'all', query: '', page: 1 };

    function matches(item) {
      var categoryOk = state.category === 'all' || item.dataset.blog === state.category;
      var queryOk = !state.query || item.dataset.search.indexOf(state.query) !== -1;
      return categoryOk && queryOk;
    }

    function render() {
      var filtered = items.filter(matches);
      var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
      if (state.page > totalPages) state.page = totalPages;
      var start = (state.page - 1) * perPage;
      var visible = filtered.slice(start, start + perPage);

      items.forEach(function (item) { item.hidden = true; });
      visible.forEach(function (item) { item.hidden = false; });

      if (emptyEl) emptyEl.hidden = filtered.length !== 0;
      if (paginateEl) paginateEl.hidden = totalPages <= 1;
      if (statusEl) statusEl.textContent = 'Page ' + state.page + ' of ' + totalPages;
      if (prevBtn) prevBtn.disabled = state.page <= 1;
      if (nextBtn) nextBtn.disabled = state.page >= totalPages;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('btn--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('btn--active');
        tab.setAttribute('aria-selected', 'true');
        state.category = tab.getAttribute('data-blog-filter');
        state.page = 1;
        render();
      });
    });

    if (searchEl) {
      var debounceTimer;
      searchEl.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          state.query = searchEl.value.trim().toLowerCase();
          state.page = 1;
          render();
        }, 150);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (state.page <= 1) return;
        state.page -= 1;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        state.page += 1;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-blog-archive]').forEach(initBlogArchive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBlogArchive(event.target.querySelector('[data-blog-archive]'));
  });
})();
